module.exports = __webpack_public_path__ + "img/map_kobala_thumb.231f6f92.jpg";